module.exports = {
  __init__: [ 'selectionVisuals', 'selectionBehavior' ],
  __depends__: [
    require(44),
    require(46)
  ],
  selection: [ 'type', require(49) ],
  selectionVisuals: [ 'type', require(51) ],
  selectionBehavior: [ 'type', require(50) ]
};
